import * as _ from 'underscore'

import { ConvertHelper, DataProvider, Dictionary, KeyType, ToastHelper } from "../helpers"
import { OpDataTypeInGroup, OpDataTypeGroup } from "../models/core"
import { Enums } from "../models/common"
import { ColumnInfo } from '../models/custom'
import { DataProviderListResult } from './data-provider.interfaces'
import { DataProviderRequest } from './utils'
import { IReferenceType } from 'app/models/util/interfaces'

export class DataProviderDataTypeGroup {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getDataTypeGroupFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<DataProviderListResult<OpDataTypeGroup>> => {
        return this.dataProvider.sendFilterRequestWithSession<OpDataTypeGroup>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdDataTypeGroup, 'OpxDataTypeGroupFilter', 'OpxDataTypeGroupFilterResult')
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })
    }

    public getDataTypeGroup = (idDatatypeGroup: number): DataProviderRequest<OpDataTypeGroup> => {
        const promise: JQueryPromise<OpDataTypeGroup> = this.dataProvider
            .sendRequestWithSession('OpxGetDataTypeGroup', { idDataTypeGroup: idDatatypeGroup }, 'OpxGetDataTypeGroupResult')
            .then((response: any) => {
                if (response != null) {
                    const dataTypeGroup: OpDataTypeGroup = new OpDataTypeGroup(response)

                    return OpDataTypeGroup
                        .loadNavigationProperties(this.dataProvider, [dataTypeGroup])
                        .then((group: OpDataTypeGroup[]) => {
                            return _.first(group)
                        })
                }

                return null
            })
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })

        return DataProviderRequest.fromJQuery(promise)
    }

    public getDataTypesInGroup = (idDatatypeGroup: number): JQueryPromise<OpDataTypeInGroup[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetDataTypesInGroup', { idDataTypeGroup: idDatatypeGroup }, 'OpxGetDataTypesInGroupResult')
            .then((response: any[]) => {
                if (_.size(response) > 0) {
                    const dataTypesInGroup: OpDataTypeInGroup[] = _.map(response, (value: any) => new OpDataTypeInGroup(value))

                    return OpDataTypeInGroup
                        .loadNavigationProperties(this.dataProvider, dataTypesInGroup)
                        .then((group: OpDataTypeInGroup[]) => {
                            return group
                        })
                }

                return []
            })
    }

    public saveDataTypeGroup = (opObj: OpDataTypeGroup): JQueryPromise<OpDataTypeGroup> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveDataTypeGroup', { toBeSaved: opObj.toJSON() }, 'OpxSaveDataTypeGroupResult')
            .then((response: any) => {
                const dataTypeGroup: OpDataTypeGroup = new OpDataTypeGroup(response)

                return OpDataTypeGroup.loadNavigationProperties(this.dataProvider, [dataTypeGroup])
                    .then((dtg: OpDataTypeGroup[]) => {
                        return _.first(dtg)
                    })
            })
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })
    }

    // #region Delete    

    public deleteDataTypeGroup = (idDataTypeGroup: number): JQueryPromise<void> => {
        return this.dataProvider
            .sendRequestWithSession('OpxDeleteDataTypeGroup', { idDataTypeGroup: idDataTypeGroup }, null)
            .fail((error) => {
                const msg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(msg)
            })
    }

    // #endregion

    //#region forDitionary

    public getDataTypeInGroup = (dataTypeGroupName: string, referenceType: number = null, referenceValue: number = null): JQueryPromise<OpDataTypeInGroup[]> => {
        return this.dataProvider.System
            .getDictionaries([Enums.ReferenceType.IdDataTypeGroup, Enums.ReferenceType.IdDataTypeInGroup])
            .then(dict => {
                var result: OpDataTypeInGroup[] = []
                if (!dataTypeGroupName)
                    return result

                var dataTypeGroups: OpDataTypeGroup[] = this.dataProvider.LocalStorage.tryGetDictionaryContent<OpDataTypeGroup>(dict, Enums.ReferenceType.IdDataTypeGroup)
                var dataTypesInGroup: OpDataTypeInGroup[] = this.dataProvider.LocalStorage.tryGetDictionaryContent<OpDataTypeInGroup>(dict, Enums.ReferenceType.IdDataTypeInGroup)

                var group: OpDataTypeGroup = null


                if (referenceType == null || referenceValue == null) {
                    var groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)
                    if (groups.length > 0) group = groups[0]
                } else {
                    var groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == referenceType && g.referenceValue == referenceValue)
                    if (groups.length == 0) {
                        groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)
                        if (groups.length > 0) group = groups[0]
                    } else {
                        group = groups[0]
                    }
                }

                if (group == null) return result

                const dataTypeInGroupTmp: OpDataTypeInGroup[] = _.sortBy(dataTypesInGroup.filter(d => d.idDataTypeGroup == group.idDataTypeGroup), (dataTypeInGroup: OpDataTypeInGroup) => {
                    if (dataTypeInGroup.orderNBR == null) {
                        return 0
                    } else {
                        return dataTypeInGroup.orderNBR
                    }
                })//dataTypesInGroup[group.idDataTypeGroup]//czy to wyszukiwanie naprawdę jest taki długie że tu byl potrzebny słownik?
                if (!dataTypeInGroupTmp) return result;
                else if (!group.idParentGroup)
                    return dataTypeInGroupTmp

                var dataTypeInParentGroup: OpDataTypeInGroup[] = dataTypesInGroup.filter(d => d.idDataTypeGroup == group.idParentGroup)//dataTypesInGroup[group.idDataTypeGroup]//czy to wyszukiwanie naprawdę jest taki długie że tu byl potrzebny słownik?
                if (!dataTypeInParentGroup) return dataTypeInGroupTmp

                result.push(...dataTypeInParentGroup)

                dataTypeInGroupTmp.forEach(item => {
                    var index = -1
                    result.some((d, i) => {
                        if (d.idDataType == item.idDataType) {
                            index = i
                            return true
                        }
                        return false
                    })
                    if (index > -1) {
                        result[index] = item
                    } else {
                        result.push(item)
                    }
                })

                return result
            })
    }

    public getDataTypeInGroupsWithReferenceValues = (dataTypeGroupName: string, referenceType: number = null, referenceValues: number[] = null): JQueryPromise<Dictionary<OpDataTypeInGroup[]>> => {
        return this.dataProvider.System
            .getDictionaries([Enums.ReferenceType.IdDataTypeGroup, Enums.ReferenceType.IdDataTypeInGroup])
            .then((dict: Dictionary<Dictionary<IReferenceType>>) => {
                const result: Dictionary<OpDataTypeInGroup[]> = new Dictionary([], KeyType.Number)

                if (!dataTypeGroupName) {
                    return result
                }

                const dataTypeGroups: OpDataTypeGroup[] = this.dataProvider.LocalStorage.tryGetDictionaryContent<OpDataTypeGroup>(dict, Enums.ReferenceType.IdDataTypeGroup)
                const dataTypesInGroup: OpDataTypeInGroup[] = this.dataProvider.LocalStorage.tryGetDictionaryContent<OpDataTypeInGroup>(dict, Enums.ReferenceType.IdDataTypeInGroup)

                _.forEach(referenceValues, (referenceValue: number) => {
                    let group: OpDataTypeGroup = null

                    if (referenceType == null || referenceValue == null) {
                        const groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)

                        if (groups.length > 0) {
                            group = groups[0]
                        }
                    } else {
                        let groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == referenceType && g.referenceValue == referenceValue)

                        if (groups.length == 0) {
                            groups = dataTypeGroups.filter(g => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)

                            if (groups.length > 0) {
                                group = groups[0]
                            }
                        } else {
                            group = groups[0]
                        }
                    }

                    if (group == null) {
                        result.addOrUpdate(referenceValue, [])
                        return
                    }

                    const dataTypeInGroupTmp: OpDataTypeInGroup[] = _.sortBy(dataTypesInGroup.filter(d => d.idDataTypeGroup == group.idDataTypeGroup), (dataTypeInGroup: OpDataTypeInGroup) => {
                        if (dataTypeInGroup.orderNBR == null) {
                            return 0
                        } else {
                            return dataTypeInGroup.orderNBR
                        }
                    })

                    if (!dataTypeInGroupTmp) {
                        result.addOrUpdate(referenceValue, [])
                        return
                    } else if (!group.idParentGroup) {
                        result.addOrUpdate(referenceValue, dataTypeInGroupTmp)
                    }

                    const dataTypeInParentGroup: OpDataTypeInGroup[] = dataTypesInGroup.filter(d => d.idDataTypeGroup == group.idParentGroup)

                    if (!dataTypeInParentGroup) {
                        result.addOrUpdate(referenceValue, dataTypeInGroupTmp)
                        return
                    }

                    let values: OpDataTypeInGroup[] = result.tryGetValue(referenceValue)
                    if (values == null) {
                        values = []
                    }

                    values.push(...dataTypeInParentGroup)

                    dataTypeInGroupTmp.forEach(item => {
                        let index: number = -1

                        values.some((d, i) => {
                            if (d.idDataType == item.idDataType) {
                                index = i
                                return true
                            }
                            return false
                        })

                        if (index > -1) {
                            values[index] = item
                        } else {
                            values.push(item)
                        }
                    })

                    result.addOrUpdate(referenceValue, values)
                })

                return result
            })
    }

    //#endregion

    // Public Methods End
}